import AVdxbBrandLogo from './index.vue';

AVdxbBrandLogo.install = app => {
  app.component(AVdxbBrandLogo.name, AVdxbBrandLogo);
};

export default AVdxbBrandLogo;
